<!-- <div class="bot-container"> -->
<!-- Bot button/icon goes here -->
<!-- <button *ngIf="!isOpen && showChatbot" class="chatbot-fab" (click)="openChatbot()" aria-label="Open chatbot">
  <img src="assets/chatbot.png" alt="Chatbot" style="width:32px; height:32px;" />
</button> -->

<button *ngIf="!isOpen && showChatbot" class="chatbot-fab" (mousedown)="onFabMouseDown($event)" (click)="openChatbot()"
  [ngStyle]="position.left !== null && position.top !== null ? { left: position.left + 'px', top: position.top + 'px', position: 'fixed', zIndex: 2147483647 } : {}"
  aria-label="Open chatbot">
  <img src="assets/chatbot.png" alt="Chatbot" style="width:32px; height:32px;" />
</button>

<div class="chat-container" *ngIf="isOpen && showChatbot" [ngClass]="{ 'minimized': isMinimized }"
  [ngStyle]="{ top: position.top + 'px', left: position.left + 'px' }">

  <div class="chat-header" (mousedown)="onHeaderMouseDown($event)">
    <span class="title"><img src="assets/chatbot.png" alt="Chatbot" style="width:32px; height:32px;" /> CDS
      Assistant</span>
    <!-- <span class="title" [ngClass]="{ 'minimized-title': isMinimized }" *ngIf="selectedChatbotFlow !== 'none'"> <button class="controls go-back-btn"
         (click)="goBackToFlowSelection()" title="Click to switch flow"><svg width="22" height="22"
          viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
          <path d="M12 3.3L2 11h2v9a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-9h2L12 3.3zM9 21v-6h6v6H9z" />
        </svg>
      </button>
      CDS Assistant
      <span *ngIf="selectedChatbotFlow === 'rule'">(Rule Based)</span>
      <span *ngIf="selectedChatbotFlow === 'genai'">(Gen AI Based)</span>
    </span> -->
    <div class="controls">
      <button *ngIf="!isMinimized" (click)="toggleMinimize()" title="Minimize">—</button>
      <button *ngIf="isMinimized" (click)="toggleMinimize()" title="Maximize">⤢</button>
      <button (click)="closeChatbot()" title="Close">✖</button>
    </div>
  </div>

  <div class="tab-navigation" *ngIf="!isMinimized">
    <button class="tab-btn" [class.active]="selectedChatbotFlow === 'genai'" (click)="selectChatbotFlow('genai')" *ngIf="IsGenaiChatbotEnabledd">
      Ask a question
    </button>
    <button class="tab-btn" [class.active]="selectedChatbotFlow === 'rule'" (click)="selectChatbotFlow('rule')">
      Perform Actions
    </button>
  </div>

  <!-- <div *ngIf="selectedChatbotFlow === 'none' && !isMinimized" class="chatbot-experience-selection">
    <div class="experience-title"><b>Select Your Chatbot Experience</b></div>
    <div class="experience-tiles">
      <div class="experience-tile" (click)="selectChatbotFlow('rule')">
        <div class="tile-content">
          <img src="assets/rb.png" alt="Rule-Based" class="tile-icon" />
          <div>
            <div class="tile-title"><b>Rule-Based Flow</b></div>
            <div class="tile-desc">For quick, predictable answers and guided interactions.</div>
          </div>
        </div>
      </div>
      <div class="experience-tile" (click)="selectChatbotFlow('genai')">
        <div class="tile-content">
          <img src="assets/ai.png" alt="Gen AI" class="tile-icon" />
          <div>
            <div class="tile-title"><b>Gen AI Based Flow</b></div>
            <div class="tile-desc">For creative, dynamic conversations. Powered by advanced AI.</div>
          </div>
        </div>
      </div>
    </div>
  </div> -->



  <ng-container>



    <div class="chat-messages" #chatWindow [appLoading]="isLoading" [loaderColor]="loaderBgType"
      [fixedLoader]="fixedLoader" *ngIf="!isMinimized">

      <div *ngFor="let message of messages"
        [ngClass]="{ bot: message.sender === 'bot', user: message.sender === 'user' }" class="message">
        <span *ngIf="message.text">
          <div class="ai-response" [innerHTML]="message.safeHtml ? message.safeHtml : message.text"></div>
          <a *ngIf="message.html" href="javascript:void(0)" (click)="openScenario()">{{ message.html }}</a>
        </span>

        <div *ngIf="message.options" class="options">
          <button *ngFor="let option of message.options" (click)="handleOptionClick(option)" [disabled]="isThinking">
            {{ option }}
          </button>
        </div>
      </div>

      <!-- Show spinner when bot is thinking -->
      <div *ngIf="isThinking" class="thinking-spinner">
        <span class="spinner"></span> Chatbot is processing your request...
      </div>

    </div>


    <div class="chat-input" *ngIf="!isMinimized ">
      <div class="autocomplete-wrapper">
        <!-- Ghost suggestion layer -->
        <!-- <div class="ghost-suggestion">
                <span class="typed">{{ userInput }}</span><span class="suggested">{{ projectNameSuggestion }}</span>
              </div> -->
        <!-- Actual input -->
        <input #projectNameInput id="projectNameInput" [(ngModel)]="userInput" placeholder="Type here......"
          (ngModelChange)="onInputChange($event)" (keydown)="onProjectNameInputKeydown($event)"
          (keydown.enter)="isValidFormat() && handleUserInput()" autocomplete="off" [disabled]="step === 0" />
        <ul *ngIf="showDropdown" class="project-dropdown">
          <li *ngFor="let name of filteredProjectNames" (click)="selectProjectName(name)">
            {{ name }}
          </li>
        </ul>
      </div>
      <button class="send" (click)="handleUserInput()" [disabled]="!isValidFormat() || step === 0 || isThinking">
        Send ▶
      </button>
      <button class="reset" (click)="selectedChatbotFlow == 'rule' ?  resetChat() : resetgenaiChat()"
        [disabled]="isThinking">⭮ Reset</button>
      <div *ngIf="validationError" class="input-error">{{ validationError }}</div>

    </div>
    <!-- Modern Gen AI sub-flow selection tiles, shown only in Gen AI flow and no sub-flow selected -->
    <div class="genai-subflow-toggles" *ngIf="selectedChatbotFlow === 'genai' && !isMinimized">
      <button class="subflow-toggle-btn" [class.active]="selectedGenAiSubFlow === 'websearch'"
        (click)="selectGenAiSubFlow('websearch')" title="Web Search Flow" aria-label="Web Search Flow">
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
          stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="10"></circle>
          <line x1="2" y1="12" x2="22" y2="12"></line>
          <path d="M12 2a15 15 0 0 1 0 20"></path>
          <path d="M12 2a15 15 0 0 0 0 20"></path>
        </svg>
      </button>
      <button class="subflow-toggle-btn" [class.active]="selectedGenAiSubFlow === 'generic'"
        (click)="selectGenAiSubFlow('generic')" title="Generic Gen AI Flow" aria-label="Generic Gen AI Flow">
        ✨
      </button>
    </div>

    <div class="modal-overlay" *ngIf="showScenarioModal"></div>
    <div class="scenario-modal" *ngIf="showScenarioModal">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ getScenarioSelectionLabel(modalAction) }}</h5>
          <button class="close-btn" (click)="closeScenarioModaloncancel()">✖</button>
        </div>
        <div class="modal-search-row">
          <label class="select-all" *ngIf="modalAction !== 'duplicate'">
            <input type="checkbox" [(ngModel)]="selectAllChecked" (change)="toggleSelectAll()" />
            <span>Select All</span>
          </label>
          <input type="text" class="scenario-search" [class.full-width]="modalAction === 'duplicate'"
            [(ngModel)]="scenarioSearch" (ngModelChange)="filterScenarios()" placeholder="Search scenario..."
            autocomplete="off" />
        </div>
        <div class="scenario-list grid-list">
          <div class="grid-col">
            <div *ngFor="let scenario of pagedScenarios.slice(0, pageSize / 2); let i = index" class="scenario-row">
              <label>
                <!-- <input type="checkbox" [(ngModel)]="scenario.selected" (change)="onScenarioCheckChange()" /> -->
                <input type="checkbox" [checked]="scenario.selected" (change)="onScenarioCheckChange(i)"
                  [disabled]="isScenarioCheckboxDisabled(scenario)" />
                <span [title]="scenario.ScenarioName || scenario.name">
                  {{ scenario.ScenarioName || scenario.name }}
                </span>
              </label>
            </div>
          </div>
          <div class="grid-col">
            <div *ngFor="let scenario of pagedScenarios.slice(pageSize / 2, pageSize); let i = index"
              class="scenario-row">
              <label>
                <input type="checkbox" [checked]="scenario.selected"
                  (change)="onScenarioCheckChange(i + (pageSize / 2))"
                  [disabled]="isScenarioCheckboxDisabled(scenario)" />
                <span [title]="scenario.ScenarioName || scenario.name">
                  {{ scenario.ScenarioName || scenario.name }}
                </span>
              </label>
            </div>
          </div>
        </div>
        <div class="pagination-actions" *ngIf="totalPages > 1">
          <span class="pagination-info">
            Showing {{ (currentPage - 1) * pageSize + 1 }}-{{ getEndIndex() }} of {{ scenarioList.length }}
          </span>
          <a class="pagination-link" (click)="goToPage(1)" [class.disabled]="currentPage === 1">&laquo;</a>
          <a class="pagination-link" (click)="goToPage(currentPage - 1)" [class.disabled]="currentPage === 1">&lt;</a>
          <ng-container *ngFor="let page of paginationPages">
            <a class="pagination-link" [class.active]="page === currentPage" (click)="goToPage(page)">
              {{ page }}
            </a>
          </ng-container>
          <a class="pagination-link" (click)="goToPage(currentPage + 1)"
            [class.disabled]="currentPage === totalPages">&gt;</a>
          <a class="pagination-link" (click)="goToPage(totalPages)"
            [class.disabled]="currentPage === totalPages">&raquo;</a>
        </div>
        <div class="modal-actions">
          <button class="modal-btn small primary" (click)="handleScenarioAction()"
            [disabled]="isDeleteOrRefreshDisabled()">
            {{ modalAction === 'delete' ? 'Delete' : (modalAction === 'export' ? 'Export' : (modalAction === 'duplicate'
            ?
            'Duplicate' : 'Refresh')) }}
          </button>
          <button class="modal-btn small" (click)="closeScenarioModaloncancel()">Cancel</button>
        </div>
      </div>
    </div>

    <div class="modal-overlay" *ngIf="showConfirmModal"></div>
    <div class="scenario-modal" *ngIf="showConfirmModal">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            {{ pendingAction === 'delete' ? 'Confirm Delete' : 'Confirm Refresh' }}
          </h5>
          <button class="close-btn" (click)="closeConfirmModal()">✖</button>
        </div>
        <div style="margin: 18px 0;">
          Are you sure you want to {{ pendingAction }} the selected scenarios?
        </div>
        <div class="modal-actions">
          <button class="modal-btn small primary" (click)="confirmWarningYes()">Yes</button>
          <button class="modal-btn small" (click)="closeConfirmModal()">No</button>
        </div>
      </div>
    </div>

  </ng-container>


</div>